import { render } from "./EstimatesPage.vue?vue&type=template&id=bd468a0c&scoped=true"
import script from "./EstimatesPage.vue?vue&type=script&lang=js"
export * from "./EstimatesPage.vue?vue&type=script&lang=js"

import "./EstimatesPage.vue?vue&type=style&index=0&id=bd468a0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd468a0c"]])

export default __exports__